import { render, staticRenderFns } from "./DownloadAppPage.vue?vue&type=template&id=42deb7dd&scoped=true&"
import script from "./DownloadAppPage.vue?vue&type=script&lang=js&"
export * from "./DownloadAppPage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAppPage.vue?vue&type=style&index=0&id=42deb7dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42deb7dd",
  null
  
)

export default component.exports